import { render, staticRenderFns } from "./Deficiencies.vue?vue&type=template&id=602de9a5"
import script from "./Deficiencies.vue?vue&type=script&lang=js"
export * from "./Deficiencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports